export class IsiEventHandlerList {

    _list: { [id: string]: ((sender, args) => void)[]; } = {};

    addHandler(id, handler) {
        this.getEvent(id, true).push(handler);
    }

    removeHandler(id, handler) {
        var evt = this.getEvent(id);
        if (!evt) return;
        this._list[id] = evt.filter(obj => obj !== handler);
        //Array.remove(evt, handler);
    }

    getHandler(id) {
        var evt = this.getEvent(id);
        if (!evt || (evt.length === 0)) return null;
        //On clone
        evt = evt.map(x => x);
        return function (source, args) {
            for (var i = 0, l = evt.length; i < l; i++) {
                evt[i](source, args);
            }
        };
    }

    getEvent(id, create?) {
        if (!this._list[id]) {
            if (!create) return null;
            this._list[id] = [];
        }
        return this._list[id];
    }
}